import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiPlay, FiCheck, FiClock, FiStar, FiPhone, FiMail, FiUser, FiBriefcase, FiChevronDown, FiSearch, FiFilter } from 'react-icons/fi';
import './App.css';
import HeroSection from './components/HeroSection';
import { useWorkshopTiming } from './hooks/useWorkshopTiming';

const PAYMENT_BASE_URL = "https://paymentz.aifunnels.app/product/21362/page/20167/addon-page?staffId=65130&ac=1";
const WEBHOOK_URL = "https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjYwNTY0MDYzNDA0MzE1MjY5NTUzMDUxMzAi_pc";

// Video testimonials data
const testimonialVideos = [
  {
    id: 1,
    url: "https://www.youtube.com/watch?v=v3EEtDIaC3w",
    embedId: "v3EEtDIaC3w",
    thumbnail: "https://img.youtube.com/vi/v3EEtDIaC3w/maxresdefault.jpg",
    title: "How Funnels Done Transformed My Coaching Business",
    name: "A Woman Entrepreneur Coach"
  },
  {
    id: 2,
    url: "https://youtu.be/IrfPwkcSTB0?si=4zR7J5O2aIbdr7k0",
    embedId: "IrfPwkcSTB0",
    thumbnail: "https://img.youtube.com/vi/IrfPwkcSTB0/maxresdefault.jpg",
    title: "From Struggling to 2 Lakhs: My Funnels Done Success Story",
    name: "Bridal Lead Generation Expert Coach"
  },
  {
    id: 3,
    url: "https://youtu.be/F26JiMS-w4I?si=5CoJ4w0AnUAMPYZm",
    embedId: "F26JiMS-w4I",
    thumbnail: "https://img.youtube.com/vi/F26JiMS-w4I/maxresdefault.jpg",
    title: "Overcoming Coaching Business Challenges with Funnels Done",
    name: "Coaching Business"
  },
  {
    id: 4,
    url: "https://youtu.be/yWzJt7jv5CM?si=cFmZMEoNQgvFxmh4",
    embedId: "yWzJt7jv5CM",
    thumbnail: "https://img.youtube.com/vi/yWzJt7jv5CM/maxresdefault.jpg",
    title: "How I Made 30 Lakhs in a Year by Helping a Lot of People as a Coach without Quiting my Job",
    name: "Professor"
  },
  {
    id: 5,
    url: "https://youtu.be/fUCYE7BoTJo?si=vFUxnRuWJZE2zRKI",
    embedId: "fUCYE7BoTJo",
    thumbnail: "https://img.youtube.com/vi/fUCYE7BoTJo/maxresdefault.jpg",
    title: "Want More Customers? 🤔 See How Manivanan Did It with FunnelsDone",
    name: "Trading Coach"
  },
  {
    id: 6,
    url: "https://youtube.com/shorts/L0jJ2NHIQ8w?si=vDvB1EIcSDn0lzHX",
    embedId: "L0jJ2NHIQ8w",
    thumbnail: "https://img.youtube.com/vi/L0jJ2NHIQ8w/maxresdefault.jpg",
    title: "The Secret Behind Mariyappan's Business Growth 🔥 | FunnelsDone AI",
    name: "India Jewelers Madurai"
  }
];

// Client Feedback data with images
const clientFeedbacks = [
  {
    id: 1,
    name: "A R Ahamed Junaith",
    role: "Spoken English Coach",
    image: "https://storage.files-vault.com/uploads/1760941910-ht57JBdJ4f.webp",
    quote: "21+ Lakhs Revenue in Just 10 Months — While Still Working as College Professor"
  },
  {
    id: 2,
    name: "Maria Sundar",
    role: "Stock Trader Coach",
    image: "https://storage.files-vault.com/uploads/1760942061-nsFEgCbsBd.webp",
    quote: "1,000+ Paid Members & 3.8 Lakhs Collected in Just 60 Days with Trading Webinars"
  },
  {
    id: 3,
    name: "Arjumand",
    role: "Community Growth Expert",
    image: "https://storage.files-vault.com/uploads/1760942064-I6HBtoRq5t.webp",
    quote: "60 Organic Registrations, 30 Showups, Multiple Sales in 1 Week — Zero Ads!"
  },
  {
    id: 4,
    name: "Subiya Fathima",
    role: "Bridal Leads Coach",
    image: "https://storage.files-vault.com/uploads/1760942062-cWbhjZc7n9.webp",
    quote: "Sold 5,999 Course to 19 Clients in One Day — Cleared Son's School Fee Same Week"
  },
  {
    id: 5,
    name: "Manigandan",
    role: "FiveStar",
    image: "https://storage.files-vault.com/uploads/1760942066-tiqyCho8Gf.webp",
    quote: "Tamil Solopreneurs Crossed 1 Crore in a Week, 10 Lakhs in a Month & More — Using AI Smart Funnels"
  },
  {
    id: 6,
    name: "Bindhu Madhavan",
    role: "Prompt Committee",
    image: null,
    quote: "I started with zero audience and no marketing budget. In just 60 days, I built a ₹3.8 Lakh income system with over 1,000 paid members"
  }
];

// FAQ data with exact copy
const faqData = [
  {
    id: 1,
    question: "When and where is this workshop happening?",
    answer: "This is a 3-hour LIVE online workshop in Tamil, happening every Sunday from 10 AM to 1 PM IST. Once you register, you'll get the joining link by email and WhatsApp."
  },
  {
    id: 2,
    question: "Is this session live or pre-recorded?",
    answer: "It's 100% LIVE — Abdul Hakkim himself will teach, explain step-by-step, and answer your questions in real time."
  },
  {
    id: 3,
    question: "Do I need any technical knowledge or special tools?",
    answer: "No. This workshop is designed for complete beginners — no coding or advanced tech skills needed. Everything is explained in simple Tamil."
  },
  {
    id: 4,
    question: "Will I get recordings if I can't attend live?",
    answer: "No Recording will be provided, It's Live only Workshop"
  },
  {
    id: 5,
    question: "How do I know this will actually help me?",
    answer: "It's made for complete beginners — with step-by-step help, free tools, and support, so you'll never feel lost."
  },
  {
    id: 6,
    question: "What happens after I register?",
    answer: "You'll immediately receive a confirmation email and WhatsApp message with your unique joining link, your bonus details, and instructions. You'll also get reminders so you don't miss it. OR You Can Email us at support@yinguru.com"
  },
  {
    id: 7,
    question: "What if I have more questions or get stuck later?",
    answer: "You'll get Lifetime Access to the IncomeDone Community — with courses, templates, and live support so you're never alone."
  },
  {
    id: 8,
    question: "Still have a doubt?",
    answer: "Just WhatsApp us anytime — our team is ready to help you get started with confidence. Email: support@yinguru.com WhatsApp Support."
  }
];

// Country codes for phone input
const countryCodes = [
  { code: "+91", country: "IN", flag: "🇮🇳" },
  { code: "+1", country: "US", flag: "🇺🇸" },
  { code: "+44", country: "UK", flag: "🇬🇧" },
  { code: "+65", country: "SG", flag: "🇸🇬" },
  { code: "+971", country: "AE", flag: "🇦🇪" }
];

function App() {
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    countryCode: '+91',
    phone: '',
    profession: '',
    consent: false
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [faqSearch, setFaqSearch] = useState('');
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [selectedRoleFilter, setSelectedRoleFilter] = useState('all');
  const [expandedFeedback, setExpandedFeedback] = useState({});
  const [hasAutoPopupShown, setHasAutoPopupShown] = useState(false);
  const modalRef = useRef(null);
  const firstInputRef = useRef(null);
  const autoPopupTimeoutRef = useRef(null);

  // Use workshop timing hook
  const { 
    workshopTiming, 
    countdown, 
    motivationalMessage, 
    isWorkshopToday, 
    isWorkshopTomorrow,
    urgencyLevel,
    displayDate 
  } = useWorkshopTiming();

  // Auto-popup registration modal after 10 seconds
  useEffect(() => {
    // Only show auto-popup once per session and if modal isn't already open
    if (!hasAutoPopupShown && !isFormModalOpen) {
      autoPopupTimeoutRef.current = setTimeout(() => {
        setIsFormModalOpen(true);
        setHasAutoPopupShown(true);
        
        // Track auto-popup event with Facebook Pixel
        if (typeof fbq !== 'undefined') {
          fbq('track', 'ViewContent', {
            content_name: '10XAI Tamil Founder Program - Auto Popup',
            content_category: 'Workshop',
            content_type: 'auto_popup',
            value: 97,
            currency: 'INR'
          });
        }

        // Track auto-popup with Google Tag Manager
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            'event': 'auto_popup_shown',
            'event_category': 'engagement',
            'event_label': '10XAI Tamil Founder Program',
            'value': 97
          });
        }
      }, 10000); // 10 seconds
    }

    // Cleanup function to prevent memory leaks
    return () => {
      if (autoPopupTimeoutRef.current) {
        clearTimeout(autoPopupTimeoutRef.current);
        autoPopupTimeoutRef.current = null;
      }
    };
  }, [hasAutoPopupShown, isFormModalOpen]);

  // Modal focus management and keyboard handling
  useEffect(() => {
    if (isFormModalOpen && firstInputRef.current) {
      firstInputRef.current.focus();
    }
    
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setIsFormModalOpen(false);
        setSelectedVideo(null);
      }
    };
    
    if (isFormModalOpen || selectedVideo) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isFormModalOpen, selectedVideo]);

  // Debounced FAQ search
  const handleFaqSearch = useCallback((value) => {
    setFaqSearch(value);
    if (searchTimeout) clearTimeout(searchTimeout);
    const newTimeout = setTimeout(() => {}, 300);
    setSearchTimeout(newTimeout);
  }, [searchTimeout]);

  const filteredFaqs = useMemo(() => {
    if (!faqSearch.trim()) return faqData;
    return faqData.filter(faq =>
      faq.question.toLowerCase().includes(faqSearch.toLowerCase()) ||
      faq.answer.toLowerCase().includes(faqSearch.toLowerCase())
    );
  }, [faqSearch]);

  const filteredFeedbacks = useMemo(() => {
    if (selectedRoleFilter === 'all') return clientFeedbacks;
    return clientFeedbacks.filter(feedback =>
      feedback.role.toLowerCase().includes(selectedRoleFilter.toLowerCase())
    );
  }, [selectedRoleFilter]);

  const uniqueRoles = useMemo(() =>
    ['all', ...new Set(clientFeedbacks.map(f => f.role))]
  , []);

  const toggleFaq = (faqId) => setExpandedFaq(expandedFaq === faqId ? null : faqId);

  const toggleFeedbackExpanded = (feedbackId) =>
    setExpandedFeedback(prev => ({ ...prev, [feedbackId]: !prev[feedbackId] }));

  const validateForm = () => {
    const errors = {};
    
    if (!formData.name.trim()) errors.name = 'Name is required';
    if (!formData.email.trim()) errors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email = 'Please enter a valid email';
    if (!formData.phone.trim()) errors.phone = 'Phone number is required';
    else if (!/^\d{10}$/.test(formData.phone.replace(/\s/g, ''))) errors.phone = 'Please enter a valid 10-digit phone number';
    if (!formData.profession.trim()) errors.profession = 'Profession/Role is required';
    if (!formData.consent) errors.consent = 'Please agree to the terms';
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm() || isSubmitting) return;
    
    setIsSubmitting(true);
    
    try {
      const phoneWithCountryCode = `${formData.countryCode}${formData.phone}`;
      
      // Get tracking data from URL parameters
      const trackingData = window.trackingData || {};
      
      // Prepare webhook payload with workshop timing info
      const webhookPayload = {
        name: formData.name,
        email: formData.email,
        phone: phoneWithCountryCode,
        profession: formData.profession,
        timestamp: new Date().toISOString(),
        source: 'landing_page',
        workshop_date: workshopTiming?.dateString || 'Loading...',
        workshop_urgency: urgencyLevel,
        days_until_workshop: countdown.days,
        ...trackingData // Include all tracking parameters
      };
      
      // Send to webhook
      try {
        await fetch(WEBHOOK_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(webhookPayload)
        });
      } catch (webhookError) {
        console.warn('Webhook submission failed:', webhookError);
        // Continue with payment even if webhook fails
      }
      
      // Track Facebook Pixel conversion
      if (typeof fbq !== 'undefined') {
        fbq('track', 'Lead', {
          content_name: '10XAI Tamil Founder Program Registration',
          content_category: 'Workshop',
          value: 97,
          currency: 'INR',
          custom_data: {
            workshop_date: workshopTiming?.dateString,
            urgency_level: urgencyLevel
          }
        });
      }

      // Track Google Tag Manager conversion
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          'event': 'form_submission',
          'event_category': 'engagement',
          'event_label': '10XAI Tamil Founder Program Registration',
          'value': 97,
          'currency': 'INR',
          'user_data': {
            'profession': formData.profession,
            'workshop_date': workshopTiming?.dateString,
            'urgency_level': urgencyLevel,
            'days_until_workshop': countdown.days
          }
        });
      }
      
      // Build payment URL with workshop timing info
      const paymentParams = new URLSearchParams();
      
      // Standard form fields with exact parameter names expected by payment gateway
      paymentParams.append('first_name', formData.name.trim());
      paymentParams.append('email', formData.email.trim());
      paymentParams.append('phone_no', phoneWithCountryCode);
      paymentParams.append('customer_profession', formData.profession);
      
      // Workshop timing information
      if (workshopTiming) {
        paymentParams.append('workshop_date', workshopTiming.dateString);
        paymentParams.append('workshop_time', workshopTiming.timeString);
        paymentParams.append('urgency_level', urgencyLevel);
        paymentParams.append('days_until_workshop', countdown.days.toString());
      }
      
      // Alternative parameter names (in case the gateway expects different names)
      paymentParams.append('name', formData.name.trim());
      paymentParams.append('phone', phoneWithCountryCode);
      paymentParams.append('profession', formData.profession);
      
      // Add tracking data
      Object.entries(trackingData).forEach(([key, value]) => {
        if (value) {
          paymentParams.append(key, value);
        }
      });
      
      // Construct the final payment URL
      const paymentUrl = `${PAYMENT_BASE_URL}&${paymentParams.toString()}`;
      
      // Track payment initiation
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          'event': 'begin_checkout',
          'event_category': 'ecommerce',
          'event_label': '10XAI Tamil Founder Program',
          'value': 97,
          'currency': 'INR',
          'workshop_date': workshopTiming?.dateString
        });
      }

      // Open payment page
      window.open(paymentUrl, '_blank');
      
      setShowSuccess(true);
      setIsFormModalOpen(false);
      setFormData({
        name: '',
        email: '',
        countryCode: '+91',
        phone: '',
        profession: '',
        consent: false
      });
      
      setTimeout(() => setShowSuccess(false), 5000);
      
    } catch (error) {
      console.error('Form submission error:', error);
      alert('There was an error submitting the form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (formErrors[field]) setFormErrors(prev => ({ ...prev, [field]: '' }));
  };

  const getInitials = (name) =>
    name.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2);

  // Handle manual modal open (clear auto-popup timer if it exists)
  const handleManualModalOpen = () => {
    if (autoPopupTimeoutRef.current) {
      clearTimeout(autoPopupTimeoutRef.current);
      autoPopupTimeoutRef.current = null;
    }
    setHasAutoPopupShown(true); // Prevent auto-popup from showing later
    setIsFormModalOpen(true);

    // Track manual CTA click with workshop timing
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        'event': 'cta_click',
        'event_category': 'engagement',
        'event_label': 'Manual Registration Modal Open',
        'value': 97,
        'workshop_date': workshopTiming?.dateString,
        'urgency_level': urgencyLevel
      });
    }
  };

  return (
    <div className="app">
      <AnimatePresence>
        {showSuccess && (
          <motion.div
            className="success-toast"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
          >
            <FiCheck className="success-icon" />
            Registration successful! Payment page opened in new tab.
          </motion.div>
        )}
      </AnimatePresence>

      <HeroSection openRegistration={handleManualModalOpen} />

      <motion.section
        className="problem-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              😰 இந்த பிரச்சினைகள் உங்களுக்கு இருக்கிறதா?
            </motion.h2>
            
            <div className="problem-grid">
              {[
                {
                  emoji: "💸",
                  title: "Revenue குறைவாக இருக்கிறது",
                  desc: "மாதம் மாதம் same revenue-தான். Growth இல்லை, stress மட்டும் தான் அதிகம்."
                },
                {
                  emoji: "⏰",
                  title: "Time இல்லை",
                  desc: "24/7 வேலை செய்தாலும் வளர்ச்சி இல்லை. Personal life-ம் sacrifice ஆகிறது."
                },
                {
                  emoji: "🤖",
                  title: "AI பற்றிய குழப்பம்",
                  desc: "AI tools எல்லாம் English-ல் இருக்கு. எங்க business-க்கு அதை எப்படி use பண்றதுன்னே தெரியல."
                },
                {
                  emoji: "💰",
                  title: "Marketing budget waste",
                  desc: "Facebook ads, Google ads-ல் பணம் போட்டும் சரியான ROI கிடைக்கல."
                }
              ].map((problem, index) => (
                <motion.div
                  key={index}
                  className="problem-card"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  whileHover={{ y: -8, transition: { duration: 0.2 } }}
                >
                  <h3>{problem.emoji} {problem.title}</h3>
                  <p>{problem.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </motion.section>

      <motion.section
        className="solution-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              🎯 Old Way vs 10xAI Method
            </motion.h2>
            
            <div className="comparison-table">
              <motion.div
                className="old-way"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <h3>❌ பழைய முறை</h3>
                <ul>
                  <li>Manual-ஆக எல்லாவற்றையும் செய்வது</li>
                  <li>Guesswork-ல் marketing செய்வது</li>
                  <li>அதிக நேர விரயம் (Time waste)</li>
                  <li>Inconsistent results</li>
                  <li>High operational cost</li>
                </ul>
              </motion.div>
              
              <motion.div
                className="new-way"
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                <h3>✅ 10xAI Method</h3>
                <ul>
                  <li>அனைத்து Process-களிலும் AI Automation</li>
                  <li>Data-driven marketing decisions</li>
                  <li>80% வரை நேர சேமிப்பு (time saving)</li>
                  <li>Predictable growth</li>
                  <li>புதிய ஆட்கள் இல்லாமல் business-ஐ scale செய்வது</li>
                </ul>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </motion.section>

      <section className="mentor-section py-16 bg-[#0b1324] text-gray-200">
        <div className="container mx-auto px-4">
          <motion.div
            className="mentor-content grid items-center gap-10 lg:grid-cols-2"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="flex justify-center lg:justify-end">
              <motion.div
                className="rounded-3xl border-2 border-orange-400 p-3 shadow-lg shadow-orange-500/20 bg-[#101c33]"
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
              >
                <img
                  src="https://storage.files-vault.com/uploads/1761032692-VSdwsp8AG0.png"
                  alt="AI Business Mentor - 10xAI Tamil Founder Program"
                  loading="lazy"
                  className="rounded-2xl w-full max-w-[360px] md:max-w-[400px] object-cover"
                />
              </motion.div>
            </div>

            <div className="mentor-info max-w-xl mx-auto lg:mx-0">
              <motion.h2
                className="text-3xl md:text-4xl font-bold text-orange-400 mb-6 flex items-center gap-2"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                🎯 <span>Meet Your Mentor</span>
              </motion.h2>

              <motion.p
                className="text-base md:text-lg leading-relaxed mb-6 text-gray-300"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
              >
                நான் Abdul Hakkim. Manual work-ல time waste பண்ணி, leads & sales இல்லாம ரொம்ப கஷ்டப்பட்டேன். Real problem என்னனு அப்போ தான் realise பண்ணேன்...
              </motion.p>

              <motion.ul
                className="space-y-4 text-gray-300 text-base md:text-lg"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                {[
                  {
                    emoji: "👉",
                    color: "text-yellow-400",
                    title: "The Real Reason:",
                    desc: "Proper tools-உம், ஒரு நல்ல automation system-உம் இல்லாதது தான்."
                  },
                  {
                    emoji: "✅",
                    color: "text-green-400",
                    title: "My Solution:",
                    desc: "நான் create பண்ண AI System உங்களுக்காக leads generate பண்ணும், auto follow-up பண்ணும் & உங்க நேரத்த save பண்ணும்."
                  },
                  {
                    emoji: "📈",
                    color: "text-blue-400",
                    title: "Proven Results:",
                    desc: "500+ businesses, 10x leads growth, 3x sales increase."
                  },
                  {
                    emoji: "🗣️",
                    color: "text-purple-400",
                    title: "Easy Training:",
                    desc: "Tamil-ல step-by-step training. Zero coding, 100% result நிச்சயம்."
                  }
                ].map((item, index) => (
                  <motion.li
                    key={index}
                    className="flex items-start gap-3"
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: 0.3 + index * 0.1 }}
                  >
                    <span className={`${item.color} text-xl mt-1`}>{item.emoji}</span>
                    <div className="flex-1">
                      <span className="font-medium">{item.title}</span>
                      <div className="text-gray-300 mt-1">{item.desc}</div>
                    </div>
                  </motion.li>
                ))}
              </motion.ul>

              <motion.p
                className="text-base md:text-lg text-gray-300 mt-6 leading-relaxed"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.7 }}
              >
               இன்னும் "hope" stage-ல இருக்கீங்களா? இது தான் உங்க turning point — AI use பண்ணி business-அ next level-க்கு கொண்டு போங்க! 💪
              </motion.p>

              <motion.div
                className="mt-10 grid sm:grid-cols-3 gap-5"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.8 }}
              >
                {[
                  "500+ Successful AI Implementations",
                  "₹10+ Crore Revenue Generated for Clients",
                  "Tamil + English AI Training Expert",
                ].map((text, idx) => (
                  <motion.div
                    key={idx}
                    className="flex flex-col justify-center items-center text-center bg-[#0f1a2b] border border-gray-700 rounded-2xl p-5 h-full min-h-[100px] hover:scale-[1.03] transition-transform duration-200"
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="flex items-center justify-center gap-2 mb-3">
                      <span className="text-yellow-400 font-semibold text-xl">★</span>
                    </div>
                    <span className="text-sm md:text-base font-medium text-gray-100 leading-snug">
                      {text}
                    </span>
                  </motion.div>
                ))}
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      <motion.section
        className="testimonials-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              🎬 Success Stories - Video Testimonials
            </motion.h2>
            
            <motion.p
              className="testimonials-subtitle"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              Real results from real Tamil entrepreneurs who transformed their businesses with AI
            </motion.p>
            
            <div className="video-grid">
              {testimonialVideos.map((video, index) => (
                <motion.div
                  key={video.id}
                  className="video-card"
                  onClick={() => {
                    setSelectedVideo(video);
                    // Track video play event
                    if (typeof fbq !== 'undefined') {
                      fbq('track', 'ViewContent', {
                        content_name: video.title,
                        content_type: 'video'
                      });
                    }
                    // Track with GTM
                    if (typeof window.dataLayer !== 'undefined') {
                      window.dataLayer.push({
                        'event': 'video_play',
                        'event_category': 'engagement',
                        'event_label': video.title,
                        'video_title': video.title
                      });
                    }
                  }}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  whileHover={{ scale: 1.02, y: -8 }}
                  whileTap={{ scale: 0.98 }}
                  tabIndex={0}
                  role="button"
                  aria-label={`Play testimonial video from ${video.name}`}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setSelectedVideo(video);
                    }
                  }}
                >
                  <div className="video-thumbnail">
                    <img
                      src={video.thumbnail}
                      alt={`${video.title} thumbnail`}
                      loading="lazy"
                      width="300"
                      height="200"
                    />
                    <div className="play-overlay">
                      <FiPlay className="play-icon" />
                    </div>
                  </div>
                  <div className="video-info">
                    <h4>{video.title}</h4>
                    <p>{video.name}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </motion.section>

      <motion.section
        className="client-feedback-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              What Our Clients Say
            </motion.h2>
            
            <motion.p
              className="feedback-subtitle"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              Real success stories from Tamil entrepreneurs who transformed their businesses
            </motion.p>
            
            <motion.div
              className="feedback-filter"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <FiFilter className="filter-icon" />
              <select
                value={selectedRoleFilter}
                onChange={(e) => setSelectedRoleFilter(e.target.value)}
                className="role-filter-select"
                aria-label="Filter by role"
              >
                {uniqueRoles.map(role => (
                  <option key={role} value={role}>
                    {role === 'all' ? 'All Roles' : role}
                  </option>
                ))}
              </select>
            </motion.div>
            
            <div className="feedback-grid">
              {filteredFeedbacks.map((feedback, index) => (
                <motion.div
                  key={feedback.id}
                  className="feedback-card"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  whileHover={{ scale: 1.02, y: -8 }}
                  whileTap={{ scale: 0.98 }}
                  tabIndex={0}
                  role="article"
                  aria-labelledby={`feedback-name-${feedback.id}`}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      toggleFeedbackExpanded(feedback.id);
                    }
                  }}
                >
                  <div className="feedback-image-container">
                    {feedback.image ? (
                      <img
                        src={feedback.image}
                        alt={`${feedback.name} - ${feedback.role}`}
                        loading="lazy"
                        width="300"
                        height="200"
                        className="feedback-rect-image"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                    ) : null}
                    <div className="avatar-fallback-rect">
                      {getInitials(feedback.name)}
                    </div>
                  </div>
                  <div className="feedback-info">
                    <h3 id={`feedback-name-${feedback.id}`}>{feedback.name}</h3>
                    <p className="feedback-role">{feedback.role}</p>
                  </div>
                  <div className="feedback-quote">
                    <p>
                      {expandedFeedback[feedback.id] || feedback.quote.length <= 140
                        ? feedback.quote
                        : `${feedback.quote.slice(0, 140)}...`}
                    </p>
                    {feedback.quote.length > 140 && (
                      <button
                        className="read-more-btn"
                        onClick={() => toggleFeedbackExpanded(feedback.id)}
                        aria-expanded={!!expandedFeedback[feedback.id]}
                        aria-controls={`feedback-quote-${feedback.id}`}
                      >
                        {expandedFeedback[feedback.id] ? 'Read less' : 'Read more'}
                      </button>
                    )}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </motion.section>

      <motion.section
        className="bonus-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              🎁 Exclusive Bonus Vault (Worth ₹25,000)
            </motion.h2>
            
            <div className="bonus-grid">
              {[
                {
                  img: "https://storage.files-vault.com/uploads/1760966854-BXbDBFXvqB.png",
                  emoji: "🤖",
                  title: "AI Tools Starter Pack",
                  desc: "50+ verified AI tools list with Tamil tutorials (Worth ₹5,000)"
                },
                {
                  img: "https://storage.files-vault.com/uploads/1760966871-XKw3XTHpgg.png",
                  emoji: "📊",
                  title: "Business Automation Templates",
                  desc: "Ready-to-use automation workflows for Tamil businesses (Worth ₹8,000)"
                },
                {
                  img: "https://storage.files-vault.com/uploads/1760976790-fakmsXQpOV.png",
                  emoji: "💬",
                  title: "Private Tamil AI Community",
                  desc: "Lifetime access to exclusive Tamil entrepreneurs AI group (Worth ₹7,000)"
                },
                {
                  img: "https://storage.files-vault.com/uploads/1760977051-dmxHkhczed.png",
                  emoji: "📞",
                  title: "1-on-1 AI Strategy Call",
                  desc: "Personal 30-minute session to customize AI for your business (Worth ₹5,000)"
                }
              ].map((bonus, index) => (
                <motion.div
                  key={index}
                  className="bonus-item"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  whileHover={{ y: -8, scale: 1.02 }}
                >
                  <img src={bonus.img} alt={bonus.title} className="bonus-image" />
                  <h3>{bonus.emoji} {bonus.title}</h3>
                  <p>{bonus.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </motion.section>

      <motion.section
        className="faq-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.div className="section-content">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              Frequently Asked Questions
            </motion.h2>
            
            <motion.p
              className="faq-subtitle"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              Got questions? We've got answers. Find everything you need to know about our program.
            </motion.p>
            
            <motion.div
              className="faq-search"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <FiSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search questions..."
                value={faqSearch}
                onChange={(e) => handleFaqSearch(e.target.value)}
                className="search-input"
                aria-label="Search frequently asked questions"
              />
            </motion.div>
            
            <div className="faq-accordion">
              {filteredFaqs.map((faq, index) => (
                <motion.div
                  key={faq.id}
                  className="faq-item"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                >
                  <button
                    className="faq-question"
                    onClick={() => toggleFaq(faq.id)}
                    aria-expanded={expandedFaq === faq.id}
                    aria-controls={`faq-answer-${faq.id}`}
                    id={`faq-question-${faq.id}`}
                  >
                    <span>{faq.question}</span>
                    <FiChevronDown className={`chevron-icon ${expandedFaq === faq.id ? 'expanded' : ''}`} />
                  </button>
                  <AnimatePresence>
                    {expandedFaq === faq.id && (
                      <motion.div
                        id={`faq-answer-${faq.id}`}
                        className="faq-answer"
                        role="region"
                        aria-labelledby={`faq-question-${faq.id}`}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="faq-answer-content">
                          {faq.answer}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
            </div>
            
            {filteredFaqs.length === 0 && (
              <motion.div
                className="faq-no-results"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              >
                <p>No questions found matching your search. Try different keywords.</p>
              </motion.div>
            )}
          </motion.div>
        </div>
      </motion.section>

      <motion.section
        className="final-cta"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.div className="cta-content">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              🔥 Limited Time Offer - Only 50 Seats Available!
            </motion.h2>
            
            <motion.p
              className="cta-subtitle"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              Regular Price: ₹2,997 | Today Only: ₹97 (97% Discount)
            </motion.p>
            
            <motion.div
              className="countdown-timer large"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <FiClock className="clock-icon" />
              <span>Batch Starts In: </span>
              <div className="timer-display">
                <div className="timer-unit">
                  <motion.span
                    className="timer-number"
                    key={countdown.days}
                    initial={{ scale: 1.2 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    {String(countdown.days || 0).padStart(2, '0')}
                  </motion.span>
                  <span className="timer-label">Days</span>
                </div>
                <div className="timer-unit">
                  <motion.span
                    className="timer-number"
                    key={countdown.hours}
                    initial={{ scale: 1.2 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    {String(countdown.hours || 0).padStart(2, '0')}
                  </motion.span>
                  <span className="timer-label">Hours</span>
                </div>
                <div className="timer-unit">
                  <motion.span
                    className="timer-number"
                    key={countdown.minutes}
                    initial={{ scale: 1.2 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    {String(countdown.minutes || 0).padStart(2, '0')}
                  </motion.span>
                  <span className="timer-label">Minutes</span>
                </div>
                <div className="timer-unit">
                  <motion.span
                    className="timer-number pulse-animation"
                    key={countdown.seconds}
                    initial={{ scale: 1.2 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    {String(countdown.seconds || 0).padStart(2, '0')}
                  </motion.span>
                  <span className="timer-label">Seconds</span>
                </div>
              </div>
            </motion.div>
            
            {/* Dynamic workshop timing display */}
            {workshopTiming && (
              <motion.div
                className="workshop-timing-display"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <div className="text-lg text-white/90 mb-2">
                  📅 Next Workshop: <span className="font-semibold text-yellow-300">{displayDate}</span>
                </div>
                {motivationalMessage && (
                  <div className="text-sm text-yellow-200">
                    {motivationalMessage}
                  </div>
                )}
              </motion.div>
            )}
            
            <motion.button
              className="cta-primary large"
              onClick={() => {
                handleManualModalOpen();
                // Track CTA click
                if (typeof fbq !== 'undefined') {
                  fbq('track', 'InitiateCheckout', {
                    content_name: '10XAI Tamil Founder Program - Final CTA',
                    content_category: 'Workshop',
                    value: 97,
                    currency: 'INR'
                  });
                }
                // Track with GTM
                if (typeof window.dataLayer !== 'undefined') {
                  window.dataLayer.push({
                    'event': 'initiate_checkout',
                    'event_category': 'ecommerce',
                    'event_label': '10XAI Tamil Founder Program - Final CTA',
                    'value': 97,
                    'currency': 'INR',
                    'workshop_date': workshopTiming?.dateString,
                    'urgency_level': urgencyLevel
                  });
                }
              }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              whileHover={{ scale: 1.05, y: -4 }}
              whileTap={{ scale: 0.95 }}
            >
              {isWorkshopToday || isWorkshopTomorrow 
                ? `Register NOW - Workshop ${isWorkshopToday ? 'TODAY' : 'TOMORROW'}! ₹97 🚀`
                : 'Yes! Reserve My Seat Now - ₹97 🚀'
              }
            </motion.button>
            
            <motion.div
              className="guarantee-text"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              <FiCheck className="check-icon" />
              <span>100% Money Back Guarantee - No Questions Asked</span>
            </motion.div>
          </motion.div>
        </div>
      </motion.section>

      <AnimatePresence>
        {isFormModalOpen && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={(e) => {
              if (e.target === e.currentTarget) setIsFormModalOpen(false);
            }}
          >
            <motion.div
              className="modal-content"
              id="registration-modal"
              initial={{ opacity: 0, scale: 0.8, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.8, y: 20 }}
              ref={modalRef}
            >
              <div className="modal-header">
                <h3>🚀 Register for 10xAI Tamil Founder Program</h3>
                <button
                  className="close-button"
                  onClick={() => setIsFormModalOpen(false)}
                  aria-label="Close registration form"
                >
                  <FiX />
                </button>
              </div>
              
              {/* Workshop timing display in modal */}
              {workshopTiming && (
                <div className="px-8 pb-4">
                  <div className="bg-orange-100 border border-orange-300 rounded-lg p-3 text-center">
                    <div className="text-orange-800 font-semibold text-sm">
                      📅 Next Workshop: {displayDate}
                    </div>
                    {urgencyLevel !== 'normal' && (
                      <div className="text-orange-600 text-xs mt-1">
                        {motivationalMessage}
                      </div>
                    )}
                  </div>
                </div>
              )}
              
              <form onSubmit={handleSubmit} className="registration-form">
                <div className="form-group">
                  <label htmlFor="name">
                    <FiUser className="input-icon" />
                    Full Name *
                  </label>
                  <input
                    ref={firstInputRef}
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    placeholder="Enter your full name"
                    className={formErrors.name ? 'error' : ''}
                    aria-describedby={formErrors.name ? 'name-error' : undefined}
                  />
                  {formErrors.name && (
                    <span id="name-error" className="error-message" role="alert">
                      {formErrors.name}
                    </span>
                  )}
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">
                    <FiMail className="input-icon" />
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    placeholder="Enter your email address"
                    className={formErrors.email ? 'error' : ''}
                    aria-describedby={formErrors.email ? 'email-error' : undefined}
                  />
                  {formErrors.email && (
                    <span id="email-error" className="error-message" role="alert">
                      {formErrors.email}
                    </span>
                  )}
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone">
                    <FiPhone className="input-icon" />
                    Phone Number *
                  </label>
                  <div className="phone-input-group">
                    <select
                      value={formData.countryCode}
                      onChange={(e) => handleInputChange('countryCode', e.target.value)}
                      className="country-select"
                      aria-label="Country code"
                    >
                      {countryCodes.map((country) => (
                        <option key={country.code} value={country.code}>
                          {country.flag} {country.code}
                        </option>
                      ))}
                    </select>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={(e) => handleInputChange('phone', e.target.value.replace(/\D/g, ''))}
                      placeholder="9884899080"
                      className={formErrors.phone ? 'error' : ''}
                      aria-describedby={formErrors.phone ? 'phone-error' : undefined}
                      maxLength="10"
                    />
                  </div>
                  {formErrors.phone && (
                    <span id="phone-error" className="error-message" role="alert">
                      {formErrors.phone}
                    </span>
                  )}
                </div>
                
                <div className="form-group">
                  <label htmlFor="profession">
                    <FiBriefcase className="input-icon" />
                    Profession/Role *
                  </label>
                  <select
                    id="profession"
                    name="profession"
                    value={formData.profession}
                    onChange={(e) => handleInputChange('profession', e.target.value)}
                    className={formErrors.profession ? 'error' : ''}
                    aria-describedby={formErrors.profession ? 'profession-error' : undefined}
                  >
                    <option value="">Select your profession</option>
                    <option value="Entrepreneur">Entrepreneur</option>
                    <option value="Business Owner">Business Owner</option>
                    <option value="Startup Founder">Startup Founder</option>
                    <option value="Freelancer">Freelancer</option>
                    <option value="Consultant">Consultant</option>
                    <option value="Executive">Executive</option>
                    <option value="Other">Other</option>
                  </select>
                  {formErrors.profession && (
                    <span id="profession-error" className="error-message" role="alert">
                      {formErrors.profession}
                    </span>
                  )}
                </div>
                
                <div className="form-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={formData.consent}
                      onChange={(e) => handleInputChange('consent', e.target.checked)}
                      className={formErrors.consent ? 'error' : ''}
                      aria-describedby={formErrors.consent ? 'consent-error' : undefined}
                    />
                    <span className="checkmark"></span>
                    I agree to receive updates about the program and understand the terms & conditions *
                  </label>
                  {formErrors.consent && (
                    <span id="consent-error" className="error-message" role="alert">
                      {formErrors.consent}
                    </span>
                  )}
                </div>
                
                <button type="submit" className="submit-button" disabled={isSubmitting}>
                  {isSubmitting ? 'Processing...' : 
                    (isWorkshopToday || isWorkshopTomorrow) 
                      ? `Register NOW - Workshop ${isWorkshopToday ? 'TODAY' : 'TOMORROW'}! ₹97 🚀`
                      : 'Register Now & Pay ₹97 🚀'
                  }
                </button>
                
                <p className="form-note">
                  After registration, you'll be redirected to secure payment page.
                  <br />
                  <strong>100% Money Back Guarantee</strong>
                </p>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {selectedVideo && (
          <motion.div
            className="video-modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={(e) => {
              if (e.target === e.currentTarget) setSelectedVideo(null);
            }}
          >
            <motion.div
              className="video-modal-content"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
            >
              <div className="video-modal-header">
                <h3>{selectedVideo.title}</h3>
                <button
                  className="close-button"
                  onClick={() => setSelectedVideo(null)}
                  aria-label="Close video"
                >
                  <FiX />
                </button>
              </div>
              <div className="video-embed-container">
                <iframe
                  src={`https://www.youtube.com/embed/${selectedVideo.embedId}?autoplay=1&rel=0`}
                  title={selectedVideo.title}
                  allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
              <div className="video-fallback">
                <p>
                  Can't view the video?
                  <a
                    href={selectedVideo.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open on YouTube
                  </a>
                </p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <p>&copy; 2025 10xAI Founder. All rights reserved.</p>
            <p>Transform your business with AI. Made with ❤️ for Tamil entrepreneurs.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;